import Auth from '../modules/Authentication'
import {apiUrl} from '../variables'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const ProductApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/?select=*`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  },
  read: key => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/${key}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  getLinesByProduct: key => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/lines/${key}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  },
  readCategory: id => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/categories?id=${id}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  },
  operation: (operation, data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}products/${operation}`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  lines: {
    list: () => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}products/lines/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
    create: data => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}products/lines/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: data => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}products/lines/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: data => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}products/lines/`, {
        headers: headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  },
}
